import {
  Button,
  Dialog,
  DialogContent,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import { useSelector } from "react-redux";
import {
  generateReportStandard,
  getLinkedTemplates,
} from "../../Restclient/datacollection";
import Box from "@mui/material/node/Box";
import LK_Loading from "../../images/LK_Loading.gif";

export default function Reports() {
  const tabpathselected = useSelector(
    (state) => state.mainpagedata.selectedtabpath,
  );
  const dateselected = useSelector((state) => state.mainpagedata.selecteddate);
  const sdate_edate_selected = useSelector(
    (state) => state.mainpagedata.selecteddates,
  );
  const theme = useSelector((state) => state.themedata.theme);

  const [tableData, setTableData] = useState([]);
  const [templates, setTemplates] = useState([]);

  const restcallbacktemplates = (res) => {
    setTableData(res.data.names);
    setTemplates(res.data.ids);
  };
  useEffect(() => {
    if (tabpathselected.length != 0) {
      getLinkedTemplates(tabpathselected, restcallbacktemplates);
    }
  }, [tabpathselected]);

  const [isDataLoading, setIsDataLoading] = useState(false);
  const [reportView, setReportView] = useState(false);
  const [file, setFile] = useState();

  const handleClose = (event, reason) => {
    if (reason === "closeButton") {
      setReportView(false);
      setFile();
    }
  };

  const callbackReport = (resfile) => {
    setIsDataLoading(false);
    const blob = new Blob([resfile], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    setFile(url);
  };

  const handleGenerateReport = (templateID) => {
    // if (
    //   selectedGroup === "" ||
    //   selectedTemplate === "" ||
    //   startDT === "" ||
    //   endDT === ""
    // ) {
    //   setUpdate(3);
    //   return;
    // }
    setIsDataLoading(true);
    generateReportStandard(
      dateselected,
      templateID,
      sdate_edate_selected.repstartdates.toString(),
      sdate_edate_selected.rependdates.toString(),
      [],
      "Portrait",
      callbackReport,
    );
    setReportView(true);
  };

  return (
    <div style={{ padding: "8px" }}>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          paddingLeft: "0px",
          paddingRight: "0px",
          backgroundColor: "var(--secondary-backgroundLK)",
        }}
        elevation={0}
      >
        <Table stickyHeader sx={{ width: "100%" }}>
          <TableBody>
            {tableData.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  height: "12px",
                  "& > *": {
                    borderBottom: "1px solid var(--GreyBaseColor)",
                  },
                }}
              >
                {index === 1 && <></>}
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "var(--SecondaryText)",
                  }}
                >
                  {row}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "var(--SecondaryText)",
                    textAlign: "right",
                  }}
                >
                  <CustomActionButton
                    onClick={() => handleGenerateReport(templates[index])}
                    buttonText={"View"}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {
        <Dialog
          maxWidth={"xl"}
          open={reportView}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              event.preventDefault();
            } else {
              handleClose(event, reason);
            }
          }}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            sx: {
              backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
              boxShadow: "none",
              borderRadius: "0px",
            },
          }}
          BackdropProps={{
            sx: {
              backgroundColor:
                theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
            },
          }}
        >
          <DialogContent>
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  Report
                </Typography>
                <Box sx={{ flexGrow: 1 }}> </Box>

                <Button
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    width: "60px",
                    height: "30px",
                    borderRadius: "20px",
                    borderColor: "#5B5B5B",
                    color: "#5B5B5B",
                  }}
                  onClick={(event) => handleClose(event, "closeButton")}
                >
                  {" "}
                  Close{" "}
                </Button>
              </Box>
              {isDataLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "calc(100vh - 200px)",
                    width: "1000px",
                  }}
                >
                  <img
                    src={LK_Loading}
                    alt="Loading..."
                    className="loading-popup" // Adjust size here
                  />
                </Box>
              ) : (
                <iframe
                  className="Test 123 iframe-report"
                  src={file}
                  type="application/pdf"
                  width="1000px"
                  aria-label="PDF file"
                ></iframe>
              )}
            </>
          </DialogContent>
        </Dialog>
      }
    </div>
  );
}
